import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import SectionHeading from "@/components/feature/SectionHeading";
import VideoCard from "@/components/feature/VideoCard";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import { videos } from "@/mocks/videos";
import { getFeatured } from "@/lib/videoUtils";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "多多视频 - 高清影视资源分享与精彩视频播放平台",
    description:
      "多多视频提供丰富的影视资源和精彩视频内容，涵盖电影、电视剧和短视频，满足用户多样化观看需求。用户可轻松浏览热门影视，发现精彩作品。",
    keywords: "多多视频,视频平台,影视资源,电影电视剧,精彩视频,视频内容,高清视频,影视播放",
  });

  const featured = getFeatured();
  const hotList = [...videos].sort((a, b) => b.rating - a.rating).slice(0, 8);
  const newList = [...videos]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <div className="min-h-screen bg-background-950">
      <SiteNavbar />
      <main>
        <h1 className="sr-only">多多视频 - 高清影视资源分享与精彩视频播放平台</h1>

        <HeroCarousel items={featured} />

        <CategoryEntry />

        <section className="mx-auto w-full max-w-[1280px] px-4 pt-14 md:px-6 md:pt-20">
          <SectionHeading
            icon="ri-fire-line"
            title="热门视频"
            subtitle="近期最受观众欢迎的高分影视作品"
            moreTo="/category/movie"
            moreLabel="更多热门"
          />
          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
            {hotList.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>

        <section className="mx-auto w-full max-w-[1280px] px-4 pt-14 md:px-6 md:pt-20">
          <SectionHeading
            icon="ri-flashlight-line"
            title="新片速递"
            subtitle="刚刚上线的最新影视，追更不错过"
            moreTo="/category/tv"
            moreLabel="更多新片"
          />
          <div className="no-scrollbar mt-6 flex gap-4 overflow-x-auto pb-2 md:gap-5">
            {newList.map((video) => (
              <VideoCard key={video.id} video={video} variant="compact" />
            ))}
          </div>
        </section>

        <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-6 rounded-lg border border-background-800 bg-background-900 p-6 md:grid-cols-3 md:p-10">
            <div className="md:col-span-2">
              <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
                关于多多视频
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-300 md:text-base">
                多多视频是一家专注于高清影视资源分享与精彩视频播放的平台，覆盖电影、电视剧及短视频内容。我们致力于为影视爱好者提供高清画质、丰富类别与便捷的浏览体验，帮助你快速发现并欣赏热门影视作品。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-300 md:text-base">
                平台支持按类别浏览、关键词搜索、地区与年份筛选以及个性化推荐，让每一次观影都轻松愉快。
              </p>
            </div>
            <div className="flex flex-col justify-center gap-4 rounded-lg bg-background-950/60 p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
                  <i className="ri-movie-2-line text-xl" />
                </span>
                <div>
                  <div className="font-heading text-lg font-bold text-foreground-50">5,000+</div>
                  <div className="text-xs text-foreground-400">高清影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300">
                  <i className="ri-user-star-line text-xl" />
                </span>
                <div>
                  <div className="font-heading text-lg font-bold text-foreground-50">320万+</div>
                  <div className="text-xs text-foreground-400">影视爱好者</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}